import Props from "./props";
import styled from "styled-components";

const FlexWrapper = styled.div<Props>`
    display: flex;
`;

export default FlexWrapper;
